var s = Math.abs, u = String.fromCharCode, i = Object.assign;
function c(n, r) {
  return e(n, 0) ^ 45 ? (((r << 2 ^ e(n, 0)) << 2 ^ e(n, 1)) << 2 ^ e(n, 2)) << 2 ^ e(n, 3) : 0;
}
function o(n) {
  return n.trim();
}
function a(n, r) {
  return (n = r.exec(n)) ? n[0] : n;
}
function f(n, r, t) {
  return n.replace(r, t);
}
function h(n, r, t) {
  return n.indexOf(r, t);
}
function e(n, r) {
  return n.charCodeAt(r) | 0;
}
function l(n, r, t) {
  return n.slice(r, t);
}
function m(n) {
  return n.length;
}
function p(n) {
  return n.length;
}
function b(n, r) {
  return r.push(n), n;
}
function d(n, r) {
  return n.map(r).join("");
}
function g(n, r) {
  return n.filter(function(t) {
    return !a(t, r);
  });
}
export {
  s as abs,
  b as append,
  i as assign,
  e as charat,
  d as combine,
  g as filter,
  u as from,
  c as hash,
  h as indexof,
  a as match,
  f as replace,
  p as sizeof,
  m as strlen,
  l as substr,
  o as trim
};
//# sourceMappingURL=index.es345.js.map
